import { FC } from 'react';

import { PieChartDataItem } from './PieChart';
import { TooltipContentProps } from 'recharts';

type CustomLineChartTooltipProps = Partial<TooltipContentProps<number, string>>;

export const CustomPieChartTooltip: FC<CustomLineChartTooltipProps> = ({ active, payload }) => {
  if (!active || !payload?.length) return null;

  const { name, value } = payload[0].payload as PieChartDataItem;

  return (
    <div className="bg-white px-3 py-2.5 outline outline-custom-warm-grey-200 rounded-[12px] shadow-custom-tooltip min-w-[144px]">
      <p className="text-body-12-regular text-custom-warm-grey-600 mb-1">{name}</p>
      <p className="text-body-12-medium text-black">{value} employees</p>
    </div>
  );
};
